import { Dispatch } from 'redux';
import CrudActionContainer from './CrudActionContainer';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import SendGridController from '../controllers/SendGridController';
import commonHandler from '../errorHandlers/common-handler';
import {
  SendGridAccount,
  SendGridAccountsResponse,
} from '../model/SendGridModel';
import { emailAccountCRUDActions } from './EmailAccountCRUDActions';

class SendGridCRUDActions extends CrudActionContainer {
  retrievedAllAccounts: string;

  constructor() {
    super('SENDGRID');
    this.retrievedAllAccounts = this.makeActionKey(
      'RETRIEVED_SENDGRID_ACCOUNTS',
    );
  }

  getAccounts(apiKey: string | number) {
    return async (
      dispatch: Dispatch<StoreState>,
    ): Promise<SendGridAccountsResponse> => {
      try {
        const result: SendGridAccountsResponse =
          await SendGridController.getAccounts(apiKey);
        dispatch({
          type: this.retrievedAllAccounts,
          payload: result.emails,
        });
        return result;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  createAccounts(
    apiKey: string | number,
    facebookPageId: number,
    accounts: {
      [key: string]: SendGridAccount;
    },
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy());
      try {
        const result = await SendGridController.createAccounts({
          apiKey,
          facebookPageId,
          accounts,
        });
        dispatch(emailAccountCRUDActions.getAccounts(facebookPageId));
        return result;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }
}

const sendGridCRUDActions = new SendGridCRUDActions();

export default sendGridCRUDActions;

export const useSendGridCRUDActions = getActionHookBuilder(
  sendGridCRUDActions,
  ['getAccounts', 'createAccounts'],
);
